"use strict";

import React from 'react/addons';
import {FluxMixin, StoreWatchMixin} from 'fluxxor';
import Icon from 'ofs/components/common/Icon';

import OFS_I18N from 'ofs/i18n'

var gettext = OFS_I18N.gettext;
var interpolate = OFS_I18N.interpolate;

import HomesListItem from './HomesListItem';

var messages = {
  LOADING: gettext("Loading ..."),
  SHOW_FEWER: gettext("Show fewer homes"),
  SHOW_MORE: gettext('Show %(count)s more homes')
}


var HomesList = React.createClass({

  messages: messages,

  mixins: [
    React.addons.PureRenderMixin,
    FluxMixin(React),
    StoreWatchMixin('SimilarHomes')
  ],

  getStateFromFlux() {
    return this.getFlux().store('SimilarHomes').getState();
  },

  getInitialState() {
    return {
      expanded: false,
      rowSize: 4
    };
  },

  componentDidMount() {
    this.getFlux().actions.similarHomes.load();
    window.addEventListener('resize', this.updateRowSize);
  },

  componentDidUpdate() {
    this.updateRowSize();
  },

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateRowSize);
  },

  handleClick(event) {
    event.preventDefault();
    this.setState({
      expanded: !this.state.expanded
    });
  },

  updateRowSize() {
    const component = React.findDOMNode(this);
    const width = component.offsetWidth;
    const liWidth = component.getElementsByTagName('li')[0].offsetWidth;
    this.setState({
      rowSize: Math.floor(width/liWidth)
    });
  },

  render() {
    var {homes, rowSize, expanded, loaded} = this.state;
    var label;
    var icon;
    var homesSlice = homes;
    var loadingLabel = messages.LOADING;

    if (!expanded) {
      homesSlice = homes.slice(0, rowSize);
    }

    var remainder = homes.length - homesSlice.length;
    var visibleHomes = homesSlice.map(function(home) {
      home.key = home.url;
      return <HomesListItem {...home} />;
    });

    if (expanded) {
      icon = <Icon glyph="arrow" size="small" variant="up" />;
      label = messages.SHOW_FEWER;
    } else {
      icon = <Icon glyph="arrow" size="small" variant="right" />;
      label = interpolate(messages.SHOW_MORE, {count: remainder}, true);
    }

    return (
      <div className="ofs-HomesList">
        {loaded ?
          <ul className="ofs-List ofs-List--horizontal">
            {visibleHomes}
          </ul> : {loadingLabel}}
        {loaded && (expanded || remainder > 0) ? <div className="ofs-HomesList__Toggler">
          <a ref="callToAction" onClick={this.handleClick} href="#" className="ofs-Link">{icon} {label}</a>
        </div> : null}
      </div>
    );
  }
});

module.exports = HomesList;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/homeslist/HomesList.jsx
 **/